export const reloadWindow = (): void => {
  window.location.reload();
};
